import React from 'react'
import useDrivePicker from 'react-google-drive-picker'

function Campus_certificate() {

    const [openPicker, authResponse] = useDrivePicker();  

    const handleOpenPicker = () => {
        openPicker({
          clientId: "xxxxxxxxxxxxxxxxx",
          developerKey: "xxxxxxxxxxxx",
          viewId: "DOCS",
          // token: token, // pass oauth token in case you already have one
          showUploadFolders: true,
          supportDrives: true,
          multiselect: true,
          // customViews: customViewsArray, // custom view
          callbackFunction: (data) => {
            if (data.action === 'cancel') {
              console.log('User clicked cancel/close button')
            }
            console.log(data)
          },
        })
      }


  const text =
    '🌟 EXCITING INTERNSHIP AWAITS YOU! 🚀/Hey Talented Minds! 🌈/🔥 InternsElite is thrilled to announce an exclusive collaboration with the creative powerhouse - E-Cell IIT Hyderabad and Nimbus NIT Hyderabad 🎉/🌐 Embark on a transformative journey with live mentorship sessions featuring professionals from tech giants like Google, Microsoft, Mastercard, Amazon, IIT, and NIT. 🚀/🚀 Level Up | Dream Big | Get Hired/Start shaping your career trajectory with our dynamic Internship opportunities, offering both Work From Home (WFH) and Work From Office (WFO) options. 🏡💼/🎓 Eligibility: No criteria, just bring your passion and enthusiasm! 🚀/🔗 Join our official group for an immersive experience and dive into the world of possibilities.🔗/Tap into the future, Link Up:/🔗 Join Now-/Seize the opportunity! 🌟 Your future begins here. 💼/🔗 Join the group now to access cutting-edge training and kickstart your journey towards success! 🔗'

  const copyToClipboard = () => {
    // Convert text with proper formatting
    const formattedText = text
      .replace(/\/(?!🔗)/g, '\n\n') // Replace slashes with new lines, except for the links
      .replace(
        '🔗 Join Now-',
        '🔗 Join Now- (https://chat.whatsapp.com/BWqavqrCtGE5x553KS38Jp)',
      )
      .replace(
        /🔗 Join Now- \(https:\/\/internselite\.net\/Code-Editor-Page\)/g,
        '🔗 Join Now- https://chat.whatsapp.com/BWqavqrCtGE5x553KS38Jp',
      )
      .replace(/^(.*)$/gm, (match) => {
        // Format bold lines
        const boldLines = [
          '🌟 EXCITING INTERNSHIP AWAITS YOU! 🚀',
          'Hey Talented Minds! 🌈',
          '🔥 InternsElite is thrilled to announce an exclusive collaboration with the creative powerhouse - E-Cell IIT Hyderabad and Nimbus NIT Hyderabad 🎉',
          '🚀 Level Up | Dream Big | Get Hired',
          '🎓 Eligibility: No criteria, just bring your passion and enthusiasm! 🚀',
          '🔗 Join our official group for an immersive experience and dive into the world of possibilities.',
          'Tap into the future, Link Up:',
          '🔗 Join the group now to access cutting-edge training and kickstart your journey towards success! 🔗',
        ]
        return boldLines.includes(match) ? `**${match}**` : match
      })

    navigator.clipboard.writeText(formattedText).then(() => {
      alert('Text copied to clipboard!')
    })
  }

  const boldLines = new Set([
    '🌟 EXCITING INTERNSHIP AWAITS YOU! 🚀',
    'Hey Talented Minds! 🌈',
    '🔥 InternsElite is thrilled to announce an exclusive collaboration with the creative powerhouse - E-Cell IIT Hyderabad and Nimbus NIT Hyderabad 🎉',
    '🚀 Level Up | Dream Big | Get Hired',
    '🎓 Eligibility: No criteria, just bring your passion and enthusiasm! 🚀',
    '🔗 Join our official group for an immersive experience and dive into the world of possibilities.',
    'Tap into the future, Link Up:',
    '🔗 Join the group now to access cutting-edge training and kickstart your journey towards success! 🔗',
  ])

  const renderTextWithBoldAndLink = (line, index) => {
    const trimmedLine = line.trim()

    if (trimmedLine === '🔗 Join Now-') {
      return (
        <span key={index}>
          <strong>{trimmedLine}</strong>{' '}
          <a
            href="https://chat.whatsapp.com/BWqavqrCtGE5x553KS38Jp"
            target="_blank"
            rel="noopener noreferrer"
          >
            (https://chat.whatsapp.com/BWqavqrCtGE5x553KS38Jp)
          </a>
        </span>
      )
    }

    if (boldLines.has(trimmedLine)) {
      return <strong key={index}>{trimmedLine}</strong>
    }

    return trimmedLine
  }

  return (
    <div>
      {/* -----------------------Mobile View------------------------ */}
      <div className="Combo_background_image d-sm-block d-md-none mt-5">
        <div className="container-fluid Combo_background_color pt-5">
          <div className="text-center Combo_Main_text py-5">
            <h2 className="display-2 text-white">
              Campus Ambassador Certificate
            </h2>
          </div>
        </div>
      </div>

      {/* -------------------Desktop View------------------------- */}
      <div className="Combo_background_image d-none d-md-block mt-5">
        <div className="container-fluid Combo_background_color py-5">
          <div className="text-center pt-5 Combo_Main_text mt-5">
            <h2 className="display-4 py-5 my-5 text-white">
              Campus Ambassador Certificate
            </h2>
          </div>
        </div>
      </div>

      <div className="container my-5">
        <div className="row">
          <div className="col-md-12 my-2 d-sm-block d-md-none">
            <div className="Campus_certificate_copy_text_mobile">
              <h2 className="text-center">Copy to Clipboard!</h2>
              <div className="border p-2 rounded shadow my-3">
                {text.split('/').map((line, index) => (
                  <p key={index}>{renderTextWithBoldAndLink(line, index)}</p>
                ))}
              </div>
              <button
                className="text-white shadow-sm fs-5 px-5 pt-1 pb-2 Pr_details_button"
                onClick={copyToClipboard}
              >
                Copy
              </button>
            </div>
          </div>
          <div className="col-md-7 d-none d-md-block">
            <div className="Campus_certificate_copy_text">
              <h2>Copy to Clipboard!</h2>
              <div className="border p-4 rounded shadow my-4">
                {text.split('/').map((line, index) => (
                  <p key={index}>{renderTextWithBoldAndLink(line, index)}</p>
                ))}
              </div>
              <button
                className="text-white shadow-sm fs-5 px-5 pt-1 pb-2 Pr_details_button"
                onClick={copyToClipboard}
              >
                Copy
              </button>
            </div>
          </div>
          <div className="col-md-5">
            <div className="">
              <div>
                <button onClick={() => handleOpenPicker()}>Open Picker</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Campus_certificate
